module.exports = __webpack_public_path__ + "static/img/level_3.ecaaf39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/level_3.png
// module id = 7EVx
// module chunks = 1